import '../styles/loaders.less';

type PropTypes = {
  text?: string;
  className?: string;
};

const AjaxLoader = ({ text = '', className = '' }: PropTypes) => {
  return (
    <div className={'ajax-loader fade-in-with-delay ' + className}>
      <div className="middle-holder">
        <div className="loader-image"></div>
        <span className="ajax-text">{text}</span>
      </div>
    </div>
  );
};

export default AjaxLoader;
